import Box from './Box';
import Home from './Home';
import Product from './Product';
import PushNotification from './PushNotification';

export default socketMiddleware => {
    return Object.assign({}, Box(socketMiddleware), Home(socketMiddleware), Product(socketMiddleware), PushNotification(socketMiddleware));
};



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/index.js